<template>
  <div class="container-feedback">
    <MpNavbar active="feedback" />
    <MpTitle title="用户反馈" intro="展示收到的用户反馈" />
    <div class="content-table" v-show="tableData">
      <!-- height="300" :loading="loading" -->
      <vxe-toolbar >
        <template #buttons>
          <vxe-button @click="reflash">刷新</vxe-button>
          <vxe-button @click="exportDataEvent">导出.xlsx</vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-table round border highlight-hover-row resizable ref="xTable" :data="tableData">
        <vxe-table-column type="seq" width="60"></vxe-table-column>
        <!-- <vxe-table-column field="id" title="ID" width="60"></vxe-table-column> -->
        <vxe-table-column field="createTime" :formatter="formatTime" title="反馈时间" width="150"></vxe-table-column>
        <vxe-table-column field="userInfo.nickname" title="反馈人" width="150"></vxe-table-column>
        <vxe-table-column field="type" title="类型" :formatter="formatType" width="150"></vxe-table-column>
        <vxe-table-column field="content" title="反馈内容"></vxe-table-column>
      </vxe-table>
      <vxe-pager background size="small" :loading="loading" :current-page="tablePage.currentPage" :page-size="tablePage.pageSize" :total="tablePage.totalResult" :page-sizes="[10, 20, 100]" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" @page-change="handlePageChange">
      </vxe-pager>
    </div>
  </div>
</template>

<script>
  import MpNavbar from '../../components/mp/navbar'
  import MpTitle from '../../components/mp/title'
  import { apiFeedback } from '../../request/api'

  export default {
    components: {
      MpNavbar,
      MpTitle
    },
    name: 'Index',
    // props: {
    //   msg: String
    // },
    data() {
      return {
        loading: false,
        tableData: null,
        tablePage: {
          currentPage: 1,
          pageSize: 10,
          totalResult: null
        }
      }
    },
    filters: {},
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.getFeedback()
      },
      reflash(){
        this.tablePage = {
          currentPage: 1,
          pageSize: 10,
          totalResult: null
        }
        this.tableData = null
        this.getFeedback()
      },
      getFeedback() {
        let self = this
        self.loading = true
        apiFeedback({
          page: self.tablePage.currentPage,
          size: self.tablePage.pageSize,
        }).then(res => {
          console.log(res.data)
          self.tableData = res.data.items
          self.tablePage.totalResult = res.data.count
          self.loading = false
        }).catch(err => {
          console.log(err)
          self.loading = false
        })
      },
      handlePageChange({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.getFeedback()
      },
      formatTime({ cellValue, row, column }) {
        let time = new Date(cellValue)
        let year = time.getFullYear()
        let month = time.getMonth() + 1
        let date = time.getDate()
        let hours = time.getHours()
        let minute = time.getMinutes()
        let second = time.getSeconds()

        if (month < 10) { month = '0' + month }
        if (date < 10) { date = '0' + date }
        if (hours < 10) { hours = '0' + hours }
        if (minute < 10) { minute = '0' + minute }
        if (second < 10) { second = '0' + second }
        return year + '.' + month + '.' + date + ' ' + hours + ':' + minute
      },
      formatType({ cellValue, row, column }) {
        if (cellValue == 1) {
          return '问题反馈'
        }
        else if (cellValue == 2) {
          return '意见和建议'
        } else {
          return '其它'
        }
      },
      exportDataEvent() {
        this.$refs.xTable.exportData({
          filename: '用户反馈',
          sheetName: 'Sheet1',
          type: 'xlsx'
        })
      },
      go(where) {
        this.$router.push('/' + where)
      },
    }
  }
</script>

<style scoped>
  .container-feedback {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;
    padding-left: 110px;
    padding-top: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
  }
</style>